import React, { useEffect, useState } from 'react';
import Loading from 'components/UI/LoadingScreen';
import { useDispatch, useSelector } from 'react-redux';
import { replace } from 'connected-react-router';
import { useLocation } from 'react-router';
import axios from 'axios';
function CheckoutCallback() {
    const location = useLocation();
    const dispatch = useDispatch();
    const [paymentStatus, setPaymentStatus] = useState();
    const [orderId, setOrderId] = useState();
    const [sessionId, setSessionId] = useState();
    const isLoggedIn = useSelector(({ user }) => user.isLoggedIn);
    useEffect(() => {
        var _a, _b, _c;
        const paymentFailed = /status=FAILED/.test(location.search);
        const paymentIsActive = /status=ACTIVE/.test(location.search);
        const orderIdMatch = (_b = (_a = /orderId=(?<orderId>\d+)&?/.exec(location.search)) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.orderId;
        const sessionIdMatch = new URLSearchParams(location.search).get('orderSession');
        setOrderId(orderIdMatch);
        setSessionId(sessionIdMatch);
        if (paymentFailed) {
            const paymentFailedRegex = /reason=(?<failureReason>\w+)&?/;
            const paymentFailureReasonMatch = paymentFailedRegex.exec(location.search);
            switch ((_c = paymentFailureReasonMatch === null || paymentFailureReasonMatch === void 0 ? void 0 : paymentFailureReasonMatch.groups) === null || _c === void 0 ? void 0 : _c.failureReason) {
                case 'exportFailed':
                    setPaymentStatus({ type: 'FAILURE', failureReasion: 'exportFailed' });
                    break;
                case 'refundFailed':
                    setPaymentStatus({ type: 'FAILURE', failureReasion: 'refundFailed' });
                    break;
                default:
                    setPaymentStatus({ type: 'FAILURE', failureReasion: 'chargeError' });
            }
        }
        else if (paymentIsActive) {
            setPaymentStatus({ type: 'ACTIVE' });
        }
    }, [location]);
    useEffect(() => {
        if (paymentStatus && paymentStatus.type == 'FAILURE') {
            dispatch({
                type: 'PLACE_ORDER_ERROR',
                payload: [
                    {
                        code: paymentStatus.failureReasion,
                        message: '5003',
                    },
                ],
            });
            dispatch(replace('/checkout'));
        }
        if (paymentStatus && paymentStatus.type == 'ACTIVE') {
            axios
                .get(`${process.env.CORE_API}/order/session/${sessionId}`)
                .then((response) => {
                dispatch({
                    type: 'ANALYTICS_2_PHASE_COMPLETE',
                    payload: response.data,
                });
            })
                .catch((err) => {
                console.error(err);
            });
            dispatch({ type: '2_PHASE_COMPLETE' });
            if (isLoggedIn) {
                dispatch(replace('/checkout/complete-logged-in', { orderId: orderId }));
            }
            else {
                dispatch(replace('/checkout/complete', { orderId: orderId }));
            }
        }
    }, [paymentStatus]);
    return React.createElement(Loading, null);
}
export default CheckoutCallback;
